module.exports = __webpack_public_path__ + "img/e_voucher_logo.e080bef9.png";